import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
import "pepsico-ds/css";
import { ThemeProvider } from "pepsico-ds";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ThemeProvider>
      <App />
    </ThemeProvider>
    <ToastContainer position={"bottom-right"} hideProgressBar />
  </Provider>
  // </React.StrictMode>
);

reportWebVitals();
